import { MedicalProfileButton } from './MedicalProfileButton';
import { StyledMedicalProfileHeader } from './MedicalProfileHeader.styled';
import { MedicalProfileModalOpener } from './MedicalProfileModal.opener';
import { SectionChipList } from './header/SectionChipList';
import { SectionSummaryLoader } from './header/SectionSummary.loader';

type MedicalProfileHeaderProps = {
   readonly patientId: number;
   readonly readonly: boolean;
};

export const MedicalProfileHeader = (props: MedicalProfileHeaderProps): JSX.Element => (
   <MedicalProfileModalOpener patientId={props.patientId} readonly={props.readonly}>
      {({ openModal, openModalWithTarget }) => (
         <StyledMedicalProfileHeader gap={4} alignItems={'center'}>
            <SectionSummaryLoader patientId={props.patientId}>
               {({ summaries }) => <SectionChipList summaries={summaries} onDetails={openModalWithTarget} />}
            </SectionSummaryLoader>
            <MedicalProfileButton onClick={openModal} />
         </StyledMedicalProfileHeader>
      )}
   </MedicalProfileModalOpener>
);
